export default {
  state: {
    lyft: {
      date: null,
      rideId: null,
      rideType: null,
      driver: {},
      show: false,
      routeUrl: '',
      enabled: false
    }
  },
  mutations: {
    setLyftData (state, data) {
      for (let field in data) {
        state.lyft[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reservation-details/lyft.js